import { useEffect, useRef, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BiCaretDown } from 'react-icons/bi';

import { useGetLinkTypesQuery } from '@/app/services/scenario-rtk.service';
import { PSButton } from '@/components/ui/button';
import { useOnClickOutside } from '@/hooks/useOutsideClick';

function TextScenarioLinkTypeComponent({ ...props }: { [x: string]: any }) {
  const { t } = useTranslation();

  const [url, setUrl] = useState('');
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);

  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setShow(false);
  });

  const getLinkTypes = useGetLinkTypesQuery({});

  const handleClick = (event: any) => {
    setShow(!show);
    setTarget(event.target);
  };

  const onSelect = (url: string, prefix: string, placeHolder: string) => {
    setUrl(url);

    props?.onChange?.({
      url,
      prefix,
      placeHolder,
    });

    setShow(false);
  };

  const [group, setGroup] = useState<'generic' | 'brands'>('brands');

  const onSelectGroup = (name: 'brands' | 'generic') => {
    setGroup(name);
  };

  useEffect(() => {
    if (props.value) {
      setUrl(props.value);
    }
  }, [props.value]);

  return (
    <div ref={ref} className="tw-relative">
      <button
        id="btn-click-link"
        className="tw-min-h-[50px] tw-shadow tw-border tw-border-gray-300  tw-rounded-lg  form-control tw-flex tw-items-center tw-justify-between tw-cursor-pointer"
        onClick={handleClick}
        type="button"
      >
        {url && url != '' && <img width={'30px'} height={'30px'} src={url} alt="" />}
        <BiCaretDown />
      </button>

      <Overlay show={show} target={target} placement="bottom-start" container={ref} containerPadding={30} offset={[20, 10]} rootClose={true}>
        <Popover id="popover-contained-link-icons" className="md:tw-min-w-[345px] custom-popover">
          <Popover.Body>
            <div className="tw-flex tw-flex-col">
              <div className="tw-self-stretch tw-p-0.5 tw-bg-gray-100 tw-rounded-lg tw-justify-center tw-items-center tw-gap-0.5 tw-inline-flex">
                <button
                  id="btn-select-brands"
                  onClick={() => {
                    onSelectGroup('brands');
                  }}
                  className={` ${
                    group == 'brands' ? 'tw-bg-white tw-shadow' : 'tw-bg-gray-100'
                  }  tw-border-none tw-cursor-pointer tw-grow tw-shrink tw-basis-0 tw-h-[38px] tw-px-[25px] tw-py-[9px]  tw-rounded-md tw-justify-center tw-items-center tw-flex`}
                  type="button"
                >
                  <div className="tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{t('MacBotLinkForm/btn-04')}</div>
                </button>

                <button
                  id="btn-select-generic"
                  onClick={() => {
                    onSelectGroup('generic');
                  }}
                  className={` ${
                    group == 'generic' ? 'tw-bg-white tw-shadow' : 'tw-bg-gray-100'
                  } tw-cursor-pointer tw-grow tw-shrink tw-basis-0 tw-h-[38px] tw-px-[25px] tw-py-[9px]  tw-rounded-md  tw-border tw-border-gray-200/10 tw-justify-center tw-items-center tw-flex`}
                  type="button"
                >
                  <div className="tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{t('MacBotLinkForm/btn-03')}</div>
                </button>
              </div>
              <div className="tw-flex tw-flex-wrap tw-gap-3 tw-mt-5 tw-items-center xl:tw-overflow-hidden tw-overflow-scroll xl:tw-justify-start tw-justify-center">
                {getLinkTypes?.data?.[group]?.map((dr: any, index: number) => (
                  <button
                    id="btn-select-link"
                    key={index}
                    className="tw-h-10 tw-w-10 tw-p-2 tw-border-none tw-bg-gray-100 tw-rounded-[99px] tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex"
                    onClick={() => {
                      onSelect(dr.cdnPath, dr.prefix, dr.placeHolder);
                    }}
                    type="button"
                  >
                    <div className="tw-w-6 tw-h-6 tw-justify-center tw-items-center flex tw-flex-col">
                      <img src={dr.cdnPath} className="tw-w-full tw-h-full" alt="" />
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
}

export default TextScenarioLinkTypeComponent;
